import { BaseController } from '@/api/BaseController';
import { API_CONTEXT } from '../config';
export default class LoginController extends BaseController {
    static login(params) {
        return super.post(API_CONTEXT + '/upms/login/doLogin', params);
    }
    static logout() {
        return super.post(API_CONTEXT + '/upms/login/doLogout', {});
    }
    static changePassword(params, httpOptions) {
        return super.post(API_CONTEXT + '/upms/login/changePassword', params, httpOptions);
    }
    static changeHeadImageUrl() {
        return API_CONTEXT + '/upms/login/changeHeadImage';
    }
    static refresh(params) {
        return super.post(API_CONTEXT + '/upms/login/refresh', params);
    }
    static captcha() {
        return super.get(API_CONTEXT + '/upms/login/captcha', {});
    }
}
